<header class="header">
  <div class="row header__inner">
    <div class="header__item">
      <!-- <img src="../../../assets/chatbotImages/avatar.png" alt="" class="avatar" /> -->
      <div>
        <h4 [style.display]="showADifferentOnlineName ? 'none':'display'">{{  schoolDetails?.name  | titlecase }}  School Payment Portal</h4>
        <h4 [style.display]="showADifferentOnlineName ? 'display':'none'"> Ada </h4>
        <span>Online</span>
      </div>
    </div>

    <!-- <div title="go to questions" style="color: #fff" (click)="routeToQuestions('questions')" class="question">
      <img  src="../../../assets/images/question_1.svg" alt="">
    </div> -->
    
  </div>
</header>
